<template>
  <!-- 支付弹窗 -->
  <div class="pay-box">
    <el-dialog
        :visible.sync="dialogVisible"
        width="21%"
        :before-close="handleClose">
      <div v-loading="loading">
        <div class="g-text-center g-weight-font red-text">
          <span class="g-font-18">￥</span>
          <span class="g-font-30">{{ price }}</span>
        </div>
        <div class="g-text-center sub-text g-m-t-8 g-font-14">
          剩余时间：{{ msg }}
        </div>
        <!--  分割线  -->
        <div class="cut-line g-rela">
          <div class="line"></div>
          <div class="left-circle"></div>
          <div class="right-circle"></div>
        </div>
        <!--  tab  -->
        <div class="g-p-l-80 g-p-r-80">
          <el-tabs v-model="activeName" @tab-click="tabClick" stretch>
            <el-tab-pane label="微信支付" name="1"></el-tab-pane>
            <!--          <el-tab-pane label="支付宝支付" name="2"></el-tab-pane>-->
          </el-tabs>
          <div class="g-text-center g-m-t-28">
            <img class="pay-code" v-if="codeUrl" ref="payCode" alt="" :src="codeUrl"/>
            <div class="pay-code" style="color: #FFFFFF" @click="getCode" v-else>点击重新获取二维码</div>
            <div class="g-m-t-20 g-flex g-row-center">
              <img src="@/assets/pay/log.png" class="icon" alt="">
              <p class="g-m-l-10 g-font-16">请使用微信扫码</p>
            </div>
            <p @click="queryPayCase(true)" style="color: red;font-size: 16px; cursor:pointer">我已付款，未跳转请点击</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {createOrder, payCase} from '@/api/pay'

export default {
  name: "popup-pay-box",
  data() {
    return {
      dialogVisible: false,
      times: 0,//单位 秒
      msg: '',
      timer: null,
      activeName: '1',
      codeUrl: '1',
      payCaseTicker: null, //查询订单情况定时器
      loading: false,
    }
  },
  props: {
    courseId: {
      type: String,
      required: true
    },
    price: {
      type: String,
    }
  },
  computed: {},
  created() {
  },
  methods: {
    getCode() {
      this.loading = true
      this.codeUrl = null
      this.times = null
      createOrder({
        productId: this.courseId,
        productType: 0,
        tradeType: 0,
      }).then(res => {
        this.loading = false
        this.codeUrl = res.codeUrl
        this.times = res.timeExpire
        // 倒计时前先调用一次方法，解决卡顿一秒的问题
        this.countTime()
        // 开始倒计时
        clearInterval(this.timer);
        this.timer = setInterval(this.countTime, 1000)
        this.nativeCheckStartTime()
      }, error => {
        this.loading = false
      })
    },
    //每隔2秒查询订单情况
    nativeCheckStartTime() {
      clearInterval(this.payCaseTicker);
      this.payCaseTicker = setInterval(() => {
        this.queryPayCase()
      }, 3000);
    },
    queryPayCase(l = false) {
      let loading;
      if (l) {
        loading = this.$loading({
          lock: true,
          background:"rgba(0, 0, 0, 0.8)",
          text: '请求中,请稍后。。。',
          spinner: "el-icon-loading"
        });
      }
      payCase(this.courseId).then((data) => {
        if (l) {
          this.$message.error(this.payFormat(data))
          loading.close()
        }
        //支付成功
        if (data === 'SUCCESS') {
          this.$message.success(this.payFormat(data))
          this.handleClose()
          this.$emit('success')
        } else {
          if (data !== "NOTPAY") {
            this.$message.error(this.payFormat(data))
          }
        }
      }, err => {
        if (l) {
          loading.close()
        }
      });
    },
    payFormat(v) {
      switch (v) {
        case 'SUCCESS':
          return '支付成功'
        case 'REFUND':
          return '转入退款'
        case 'NOTPAY':
          return '未支付'
        case 'CLOSED':
          return '已关闭'
        case 'REVOKED':
          return '已撤销(刷卡支付)'
        case 'USERPAYING':
          return '用户支付中'
        case 'PAYERROR':
          return '支付失败(其他原因，如银行返回失败)'
        case 'ACCEPT':
          return '已接收，等待扣款'
      }
      return '未知交易状态'
    },
    // 开启
    open() {
      this.dialogVisible = true
      this.getCode()
    },
    // 关闭
    handleClose() {
      clearInterval(this.payCaseTicker);
      this.dialogVisible = false
      clearInterval(this.timer);
    },
    // 倒计时
    countTime() {
      let m, min, s, second
      if (this.times === 0) {
        this.codeUrl = null
      }
      if (this.times >= 0) {
        // 分
        m = Math.floor((this.times / 60) % 60);
        min = m < 10 ? "0" + m : m;
        // 秒
        s = Math.floor(this.times % 60);
        second = s < 10 ? "0" + s : s;
        this.times--
        this.msg = min + " : " + second
      } else {
        clearInterval()
      }
    },
    // tab点击
    tabClick(e) {
      console.log(e)

      //todo...
    },
  }

}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 0 !important;
}

::v-deep .el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0.125rem;
  background: initial !important;
  z-index: 1;
}

.price {
  font-weight: bold;
}

.cut-line {
  padding: 35px 0 30px;

  .line {
    width: 85%;
    margin-left: 7.5%;
    border-top: 1px dashed #ddd;
  }

  .circle {
    width: 30px;
    height: 30px;
    background: #7b7b7c;
    position: absolute;
    border-radius: 50%;
    top: 19px;
  }

  .left-circle {
    @extend .circle;
    left: -33px;
  }

  .right-circle {
    @extend .circle;
    right: -33px;
  }
}

.pay-code {
  width: 146px;
  height: 146px;
  background: #407aff;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);
  padding: 4px;
  margin: 0 auto;
}

.icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
</style>
